import React from 'react'
import { Button } from 'antd'
import { useNavigate } from 'react-router'
import styles from './TitleButton.module.scss'

interface Props {
  icon: React.ReactNode
  onCLick: () => void
}

export const PageTitleButton = ({ icon, onCLick }: Props) => {
  const navigate = useNavigate()

  return (
    <Button
      type={'text'}
      className={styles.root}
      icon={icon}
      onClick={onCLick}
    />
  )
}
